import React, { useState } from "react";
import Button from "../Button/Button";

const validateContactForm = (formData) => {
  const errors = {};

  if (!formData.name.trim()) {
    errors.name = "Please enter your name.";
  }

  if (!formData.email.trim()) {
    errors.email = "Please enter your email.";
  } else if (!formData.email.includes("@")) {
    errors.email = "Email must include '@'.";
  }

  if (!formData.subject.trim()) {
    errors.subject = "Please enter the subject.";
  }

  if (!formData.message.trim()) {
    errors.message = "Please enter your message.";
  }

  if (!formData.mobile.trim()) {
    errors.mobile = "Please enter your mobile number.";
  } else if (!/^\d{10}$/.test(formData.mobile.replace(/\s/g, ''))) {
    errors.mobile = "Mobile number must be 10 digits.";
  }

  return errors;
};

const ContactForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    mobile: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateContactForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    const success = await onSubmit(formData);
    
    if (success) {
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
        mobile: "",
      });
    }
    
    setSubmitting(false);
  };

  return (
    <div className="contact-form card" data-aos="fade-up" data-aos-delay="300">
      <div className="card-body p-4 p-lg-5">
        <form onSubmit={handleSubmit} className="php-email-form">
          <div className="contact-input-fields row gy-4">
            <div className="col-12">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
              />
              {errors.name && <p className="error-message">{errors.name}</p>}
            </div>

            <div className="col-12">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && <p className="error-message">{errors.email}</p>}
            </div>

            <div className="col-12">
              <input
                type="tel"
                name="mobile"
                className="form-control"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleInputChange}
                maxLength="12"
              />
              {errors.mobile && <p className="error-message">{errors.mobile}</p>}
            </div>

            <div className="col-12">
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleInputChange}
              />
              {errors.subject && <p className="error-message">{errors.subject}</p>}
            </div>

            <div className="col-12">
              <textarea
                className="form-control"
                name="message"
                rows="6"
                placeholder="Message"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
              {errors.message && <p className="error-message">{errors.message}</p>}
            </div>

            <div className="col-12 text-center">
              <Button
                text={submitting ? "Submitting..." : "Submit Message"}
                size="long"
                color="default"
                disabled={submitting}
                className="w-100"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
